// Decoder for VAF's `hp` param: `redirectTo` as base64url JSON. An extra decode can't corrupt the
// value, but the param is still lost if the URL splits before it. Must match VAF's
// lib/handoffPayload.ts (same name, same shape).

/** The query parameter the opaque payload rides in. Same name VAF writes it under. */
export const HANDOFF_PAYLOAD_PARAM = 'hp';

export interface HandoffPayload {
  redirectTo?: string;
}

/** Decodes `hp`, or null when absent or malformed (callers treat both the same). */
export function decodeHandoffPayload(raw: string | null | undefined): HandoffPayload | null {
  if (!raw) {
    return null;
  }
  try {
    const base64 = raw.replace(/-/g, '+').replace(/_/g, '/');
    const parsed = JSON.parse(atob(base64));
    if (typeof parsed !== 'object' || parsed === null) {
      return null;
    }
    const { redirectTo } = parsed as Record<string, unknown>;
    return typeof redirectTo === 'string' && redirectTo ? { redirectTo } : null;
  } catch {
    return null;
  }
}

/** Copies `redirectTo` out of `hp` onto `params`. Call before reading `redirectTo`. */
export function applyHandoffPayload(params: URLSearchParams): void {
  const payload = decodeHandoffPayload(params.get(HANDOFF_PAYLOAD_PARAM));
  if (payload?.redirectTo) {
    params.set('redirectTo', payload.redirectTo);
  }
}
